import React from 'react'
import Loader from 'react-loader-spinner'
import { checkPermission, translate } from '../utils/useful'
import CustomLoader from './CustomLoader'
import Responsive from './Responsive'

class DataGrid extends React.Component {
    state = {
        // key: ''
    }


    render() {
        return (
            <div>
                <div className="d-flex flex-wrap">
                    {/* {console.log('this.props.permissionLevel',this.props.permissionLevel)} */}
                    {/* {console.log('this.props.permissionsA',this.props.permissions)} */}
                    {this.props.data?.map((prop, index) => {
                        let lock = false // TO DO
                        let requiredPermission
                        if (this.props.permissionLevel == 'applet') {
                            requiredPermission = `applet.view`
                        } else {
                            requiredPermission = `collection.${prop?._id}.view`
                        }
                        // console.log('this.props.permissions',this.props.permissions)
                        if (checkPermission(this.props.permissions, requiredPermission)) {
                            lock = false
                        }
                        let Component = this.props.component
                        if (Component && !lock) {
                            return (
                                <Responsive className={'d-flex prd-5 '} key={index} width={this.props.width} media={this.props.col ?? { xs: "12", sm: '6', md: '6', lg: "3", xl: "3" }}>
                                    <div className={(this.props.marginBottom ?? 'w-100 px-2 mb-4')} >
                                        <Component data={prop} schema={this.props.schema} lock={lock} onClick={this.props.onClick} dontShowPrice={this.props.dontShowPrice} background={this.props.background} changePage={this.props.changePage} functionsHandler={this.props.functionsHandler} settings={this.props.settings} />
                                    </div>
                                </Responsive>
                            )
                        }
                    })}
                </div>

                {(this.props.data?.length === 0 && !this.props.isLoading) && (
                    <div className="w-100 text-center ">
                        {this.props.data?.length === 0 && !this.props.isLoading && (
                            <p style={{ fontSize: 16, color: '#789', marginTop: 20 }}>{translate('found-nothing')}</p>
                        )}
                    </div>
                )}

                {(this.props.isLoading && !this.props.hideLoader) && (
                    <div className="mt-2 d-flex justify-content-center">
                        <CustomLoader isLoading={true} />
                    </div>
                )}

            </div>
        )
    }
}

export default (DataGrid);